var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64619 13.208C10.3067 13.208 10.8422 12.6726 10.8422 12.012C10.8422 11.3515 10.3067 10.816 9.64619 10.816C8.98566 10.816 8.4502 11.3515 8.4502 12.012C8.4502 12.6726 8.98566 13.208 9.64619 13.208Z",
    fill: "#1E87F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.156 13.208C13.8165 13.208 14.352 12.6726 14.352 12.012C14.352 11.3515 13.8165 10.816 13.156 10.816C12.4954 10.816 11.96 11.3515 11.96 12.012C11.96 12.6726 12.4954 13.208 13.156 13.208Z",
    fill: "#1E87F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6403 13.208C17.3009 13.208 17.8363 12.6726 17.8363 12.012C17.8363 11.3515 17.3009 10.816 16.6403 10.816C15.9798 10.816 15.4443 11.3515 15.4443 12.012C15.4443 12.6726 15.9798 13.208 16.6403 13.208Z",
    fill: "#1E87F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2922 4.55005H7.02016C5.43416 4.55005 4.16016 5.85005 4.16016 7.41005V16.328C4.16016 17.914 5.46016 19.188 7.02016 19.188H14.6902C15.8342 19.188 16.9262 19.604 17.7582 20.384L19.5002 21.996C19.7862 22.282 20.1762 22.412 20.5662 22.412C21.4502 22.412 22.1522 21.71 22.1522 20.826V7.41005C22.1522 5.82405 20.8782 4.55005 19.2922 4.55005ZM20.3322 20.332L18.9802 19.084C17.8102 17.992 16.2762 17.394 14.6642 17.394H7.02016C6.44816 17.394 5.98016 16.926 5.98016 16.354V7.41005C5.98016 6.83805 6.44816 6.37005 7.02016 6.37005H19.2922C19.8642 6.37005 20.3322 6.83805 20.3322 7.41005V20.332Z",
    fill: "#1E87F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypingIcon);
export default __webpack_public_path__ + "static/media/typingIcon.80a6b1d519b90589dda950c694aaad09.svg";
export { ForwardRef as ReactComponent };